import AppNexusPlacement from './AppNexusPlacement.js'

export default AppNexusPlacement
